interface ErrorFallbackProps {
	title: string;
	body: string;
	action: string;
}

export function ErrorFallback({ title, body, action }: ErrorFallbackProps) {
	return (
		<div
			style={{
				padding: '2rem',
				maxWidth: '32rem',
				margin: '4rem auto',
				textAlign: 'center',
				fontFamily: 'var(--font-sans, Inter, sans-serif)',
				color: 'var(--color-text, #2a2620)',
			}}
		>
			<h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>{title}</h1>
			<p style={{ marginBottom: '1.5rem', lineHeight: 1.5 }}>{body}</p>
			<button
				type="button"
				onClick={() => window.location.reload()}
				style={{
					padding: '0.75rem 1.5rem',
					background: 'var(--color-accent, #c45c3a)',
					color: 'white',
					border: 'none',
					borderRadius: '0.5rem',
					fontSize: '1rem',
					cursor: 'pointer',
				}}
			>
				{action}
			</button>
		</div>
	);
}
